// extracted by mini-css-extract-plugin
export var arrow = "_2t-6";
export var changeItem = "_2t-3";
export var changesHeader = "_2t-1";
export var changesList = "_2t-2";
export var container = "_2t-0";
export var pathLabel = "_2t-4";
export var value = "_2t-7";
export var valuesContainer = "_2t-5";